import React from 'react';
import styles from './WarningModal.scss';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { Modal } from '@/Components/Modal/Modal';
import { useLocalization } from '@/Hooks';
import { useTourActions, minWindowSize } from '@/Components/Tours/hooks/useTourActions';
import { stringUtils } from '@/Utils';
import { useSelector } from 'react-redux';
import { tourSelectors } from '@/Redux/Tours/selectors';

export const WarningModal = () => {
  const {
    buttons,
    sidebar: {
      TourStartMessage: { Title, ErrorMessage, SuccessMessage },
    },
  } = useLocalization();

  const { openWarningModal, runTour } = useTourActions();

  const currentTour = useSelector(tourSelectors.currentTour);
  const windowSize = useSelector(tourSelectors.windowSize);
  const showSuccess = windowSize >= minWindowSize;

  return (
    <Modal
      onClose={() => openWarningModal(false)}
      modalClassName={styles.modal}
      needRefDocsIcon={false}
      description={{
        title: Title,
      }}
    >
      <div className={styles.modalWrapper}>
        {showSuccess ? SuccessMessage : stringUtils.insertParamsToString(ErrorMessage, [windowSize])}
      </div>

      {showSuccess && (
        <div className={styles.buttonsWrapper}>
          <Button
            autoFocus={true}
            text={buttons.Start}
            theme={BUTTON_THEMES.SUCCESS}
            onClick={() => {
              runTour(currentTour ?? 'pageTour');
              openWarningModal(false);
            }}
          />
        </div>
      )}
    </Modal>
  );
};
